import * as Yup from "yup"

const validation_schema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required")
})

export default validation_schema
